import { useTranslation } from 'react-i18next'
import {
  CreateView,
  CreateViewHeader,
} from '~/components/refineUi/views/createView'
import { LocationForm } from './form'

export function LocationCreate() {
  const { t } = useTranslation()
  return (
    <CreateView>
      <CreateViewHeader title={t('locationsPage.create.title')} />
      <LocationForm action="create" />
    </CreateView>
  )
}
